import * as React from 'react';
import { useRef } from 'react';
import { makeStyles } from '@fluentui/react-components';

interface CollapsibleFAQProps {
  faqKey: string;
  question: string;
  children: React.ReactNode;
  expandedFaqs: { [key: string]: boolean };
  toggleFaq: (faqKey: string) => void;
}

const useStyles = makeStyles({
  faqItem: {
    background: 'rgba(255, 253, 248, 0.95)',
    padding: '1rem 1.5rem',
    borderLeft: '5px solid var(--primary-color)',
    borderRadius: '5px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    selectors: {
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: '0 3px 8px rgba(0,0,0,0.15)',
      },
    },
  },
  faqHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: 0,
  },
  faqContent: {
    overflow: 'hidden',
    transition: 'all 0.3s ease',
  },
  expandIcon: {
    fontSize: '1.2rem',
    color: 'var(--primary-color)',
    transition: 'transform 0.3s ease',
  },
  expandIconRotated: {
    transform: 'rotate(180deg)',
  },
});

const CollapsibleFAQ: React.FC<CollapsibleFAQProps> = ({ 
  faqKey, 
  question, 
  children,
  expandedFaqs,
  toggleFaq
}) => {
  const classes = useStyles();
  const contentRef = useRef<HTMLDivElement>(null);
  const isExpanded = expandedFaqs[faqKey];
  
  return (
    <div className={classes.faqItem} onClick={() => toggleFaq(faqKey)} tabIndex={0}>
      <div className={classes.faqHeader}>
        <div style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: 'var(--primary-color)' }}>{question}</div>
        <span className={`${classes.expandIcon} ${isExpanded ? classes.expandIconRotated : ''}`}>
          ▼
        </span>
      </div>
      <div 
        className={classes.faqContent}
        style={{
          maxHeight: isExpanded ? undefined : '0px',
          opacity: isExpanded ? 1 : 0,
          marginTop: isExpanded ? '1rem' : '0px',
          transition: 'all 0.3s ease'
        }}
      >
        <div ref={contentRef}>
          {children}
        </div>
      </div>
    </div>
  );
};

export default CollapsibleFAQ;